import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'

export class ConsultasFacturacionService extends BaseService<unknown> {
  constructor() {
    super({ baseUrl: 'facturacion/consultas/' })
  }

  buscar(
    tipo: 'FACTURA' | 'NOTA_CREDITO',
    tipoBusqueda: 'numero' | 'uuid',
    valor: string
  ): Promise<AxiosResponse<IResponseApi<Record<string, unknown>>>> {
    return this.http
      .get<IResponseApi<Record<string, unknown>>>('/buscar', {
        params: { tipo, tipoBusqueda, valor }
      })
      .catch(this.errorHandle)
  }
}
